<template>
  <div
    v-if="props.variants && props.variants.length > 1"
    :class="props.colors.length > 4 ? ' justify-start' : 'justify-center'"
    class="flex items-center w-full overflow-x-scroll no-scrollbar md:overflow-hidden md:justify-center"
  >
    <div
      class="flex w-fit min-w-max pb-2 md:pb-0 border-b border-[#C7C7C7] md:border-0 items-center justify-start gap-3 px-3 mt-4 mb-4 text-center md:px-0 flex-nowrap lg:gap-4 md:justify-center lg:mb-0"
    >
      <div
        v-for="(c, colorIndex) in props.colors.filter((c) => c.menu.length > 0)"
        :key="colorIndex"
        class="relative flex items-center w-auto cursor-pointer select-none min-w-fit"
        @click.prevent="() => onChangeColor(c)"
      >
        <img
          v-if="c['menu'][0].url_md"
          :src="c['menu'][0].url_md"
          :title="c.color"
          loading="eager"
          :class="
            selectedColor.color === c.color
              ? 'h-[68px] lg:h-[104px]'
              : 'h-[52px] lg:h-[80px]'
          "
        />
        <span
          v-if="selectedColor.color === c.color"
          class="absolute w-full h-1 rounded-lg bg-primary -bottom-2.5 md:hidden"
        ></span>
      </div>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  defaultColor: {
    type: Object,
    default: null,
  },
  variants: {
    type: Array,
    default: [],
  },
  colors: {
    type: Array,
    default: [],
  },
});

const emit = defineEmits();

const selectedColor = ref(props.defaultColor);

function onChangeColor(c) {
  selectedColor.value = c;
  emit("selected-color", selectedColor.value);
}
</script>